/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/browser-apis/
 */

 import "@fontsource/inter/300.css" // light
 import "@fontsource/inter/400.css" // regular
 import "@fontsource/inter/500.css" // medium
 import "@fontsource/inter/600.css" // semibold

 import './src/styles/global.css';


// ES5 way
// exports.onClientEntry = () => {
// ES6 way
export const onClientEntry = () => {
    // IntersectionObserver polyfill for gatsby-background-image (Safari, IE)
    if (!(`IntersectionObserver` in window)) {
        import(`intersection-observer`)
        console.log(`# IntersectionObserver is polyfilled!`)
    }
}